<template>
  <div class="menu_add">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :title="formData.xzqhId ? '编辑行政区划' : '新增行政区划' "
      :visible.sync="dialogVisible"
      width="756px"
      custom-class="addoredit"
      @close="close"
    >
      <el-form ref="formDataRef" :model="formData" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="上级行政区划:"
              prop="parentId"
              :rules="[{ required: true, message: '请选择上级行政区划' }]"
            >
              <el-cascader
                v-model="formData.parentId"
                :options="treeData"
                :props="defaultProps"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="行政区划名称:"
              prop="areaName"
              :rules="[{ required: true, message: '请输入行政区划名称' }]"
            >
              <el-input v-model="formData.areaName" placeholder="请输入行政区划名称" maxlength="200" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="行政区划编码:"
              prop="areaCode"
              :rules="[{ required: true, message: '请输入行政区划编码' }]"
            >
              <el-input v-model="formData.areaCode" placeholder="请输入行政区划编码" maxlength="200" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="显示顺序:"
              prop="orderNum"
              style="width: 100%"
            >
              <el-input
                v-model.number="formData.orderNum"
                type="number"
                placeholder="请输入显示顺序"
                maxlength="10"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="别名:"
              style="width: 100%"
              prop="anotherName"
            >
              <el-input v-model="formData.anotherName" placeholder="请输入别名" maxlength="200" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="简称:"
              prop="shortName"
              style="width: 100%"
            >
              <el-input v-model="formData.shortName" placeholder="请输入简称" maxlength="200" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="loading"
          @click="sureDelete"
        >确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addXZQH, updateXZQH } from '@/assets/js/xzqh'
export default {
  components: {},
  props: {
    tree: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      defaultProps: {
        emitPath: false,
        checkStrictly: true,
        value: 'xzqhId',
        children: 'children',
        label: 'areaName'
      },
      types: [
        {
          label: '超级管理员的路由',
          value: 0
        }, {
          label: '菜单路由',
          value: 1
        }, {
          label: '路由接口',
          value: 2
        }, {
          label: '接口级限制',
          value: 3
        }
      ],
      dialogVisible: false,
      formData: {
        parentId: '', // 上级行政区划ID
        areaCode: '', // 行政区划编码
        areaName: '', // 行政区划名称
        orderNum: 0, // 显示顺序
        anotherName: '', // 别名
        shortName: '' // 简称
      }
    }
  },
  computed: {
    treeData() {
      const data = this.buildFilterTree(this.tree, (b) => {
        return b.xzqhId !== this.formData.xzqhId
      })
      return [{
        xzqhId: 0,
        areaName: '中国',
        children: data
      }]
    },
    isRoot() {
      return this.formData.parentId === 0
    }
  },
  watch: {
    isRoot() {
      if (this.isRoot) {
        if (!this.formData.component) {
          this.formData.component = 'Home'
        }
        if (!this.formData.name) {
          this.formData.name = 'Home'
        }
        if (!this.formData.path) {
          this.formData.path = '/'
        }
      }
    }
  },
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {
    buildFilterTree(arr, fun) {
      const data = arr.filter(fun).map((item) => {
        item = Object.assign({}, item)
        if (item.children) {
          // 递归循环
          item.children = this.buildFilterTree(item.children, fun)
        }
        return item
      }).sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      return data
    },
    close() {
      this.$refs.formDataRef.clearValidate()
      this.$nextTick(() => {
        this.formData = {}
        this.dialogVisible = false
      })
    },
    show(row) {
      this.dialogVisible = true
      this.formData = Object.assign({}, row)
      this.$nextTick(() => {
        this.$refs.formDataRef.clearValidate()
      })
    },
    sureDelete() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.formData.parentId === this.formData.resourceId) {
            this.$message({
              type: 'warning',
              message: '父菜单不能选择自己'
            })
            this.loading = false
            return
          }
          const params = Object.assign({}, this.formData)
          let API = addXZQH
          if (this.formData.xzqhId) {
            API = updateXZQH
          }
          API(params).then(res => {
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.close()
              this.$emit('refresh')
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.menu_add {
  // background-color: white;
  background-color: #eef1f9;
  padding: 15px;
  .title {
    background-color: white;
    width: 100%;
    height: 50px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/.el-dialog__body {
    margin: 20px 0;
    padding: 0 60px;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox_down.png");
    background-size: 100% 100%;
  }
  /deep/.el-radio__input .el-radio__inner {
    border-color: none;
    background: url("../../assets/img/radiobox.png");
    background-size: 100% 100%;
    border-radius: 0;
    border: none;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    background: none;
  }
}
</style>
